import { observer } from 'mobx-react-lite'
import PhoneCall from 'models/PhoneCall'
import { useCallback, useEffect, useMemo, useState } from 'react'

type StopwatchProps = {
  startedAt: PhoneCall['startedAt']
}

const Stopwatch = ({ startedAt }: StopwatchProps) => {
  const startTime = useMemo(() => (startedAt ? new Date(startedAt).getTime() : null), [startedAt])

  const getElapsedTime = useCallback(() => {
    if (!startTime) return 0

    return new Date().getTime() - startTime
  }, [startTime])

  const [elapsedTime, setElapsedTime] = useState(() => getElapsedTime())

  useEffect(() => {
    if (startTime) {
      const intervalId = setInterval(() => {
        setElapsedTime(getElapsedTime())
      }, 1000)

      return () => clearInterval(intervalId)
    }
  }, [getElapsedTime, startTime])

  const formatTime = (time: number) => {
    let seconds = Math.floor(time / 1000)
    const minutes = Math.floor(seconds / 60)

    seconds %= 60

    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  }

  if (!startTime) {
    return null
  }

  return <p className="font-mono">{formatTime(elapsedTime)}</p>
}

export default observer(Stopwatch)
